import styled from "styled-components";
import Container from "./Container";

const ContainerForm = styled(Container)`
  max-width: 900px;
`;

export default ContainerForm;
